<template>
  <div class="bannerBox" :style="bannerStyle">
    <div class="swiper-container bannerSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <!-- 外部链接 -->
          <a
            v-if="item.url && item.url !== ''"
            :href="item.url"
            target="_blank"
          >
            <img
              class="swiper_img"
              :src="item.fileName"
              style="width: 100%; height: 100%"
            />
          </a>
          <!-- 文章列表 -->
          <a
            v-if="item.urlType == 2"
            :href="`/list/${item.url}`"
            target="_blank"
            :title="item.title"
          >
            <img
              class="swiper_img"
              :src="item.fileName"
              style="width: 100%; height: 100%"
            />
          </a>
          <!-- 文章详情 -->
          <a
            v-if="item.urlType == 3"
            :href="`/detail/${0}/${item.url}`"
            target="_blank"
            :title="item.title"
          >
            <img
              class="swiper_img"
              :src="item.fileName"
              style="width: 100%; height: 100%"
            />
          </a>
          <!-- 不跳转 -->
          <a v-if="item.urlType == 4" :title="item.title">
            <img
              class="swiper_img"
              :src="item.fileName"
              style="width: 100%; height: 100%"
            />
          </a>
          <a
            v-else
            :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
            target="_blank"
          >
            <img
              class="swiper_img"
              :src="item.fileName"
              style="width: 100%; height: 100%"
            />
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { getAdvert } from "@/api/common";
export default {
  props: {
    height: {
      type: Number,
      default: 535,
    },
  },
  data() {
    return {
      bannerList: [
        // { img: require('../assets/images/topbanner/1.jpg') },
        // { img: require('../assets/images/topbanner/2.jpg') },
        // { img: require('../assets/images/topbanner/3.jpg') },
        // { img: require('../assets/images/topbanner/4.png') },
        // { img: require('../assets/images/topbanner/5.jpg') }
      ],
      bannerStyle: {},
    };
  },
  mounted() {
    var _this = this;

    _this.bannerStyle = {
      height: _this.height + "px",
    };
    _this.bannerSwiper();
  },
  methods: {
    bannerSwiper() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        advertType: 1,
      };
      getAdvert(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          data.length &&
            data.forEach((line) => {
              if (line.fileName && line.fileName !== "") {
                _this.bannerList.push(line);
              }
            });
          this.$nextTick(() => {
            new Swiper(".bannerSwiper", {
              effect: "fade",
              loop: true,
              speed: 300,
              autoplay: 2000,
              updateOnImagesReady: true,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
              pagination: ".swiper-pagination",
              paginationClickable: true,
            });
          });
        }
      });
    },
  },
};
</script>
<style>
.bannerBox {
  width: 100%;
  /*max-width: 1920px; */
  margin: 0 auto;
  position: relative;
}
.bannerSwiper {
  height: 100%;
}
.bannerBox .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
}
</style>
